import { render, staticRenderFns } from "./card-videos.vue?vue&type=template&id=5bf50498&scoped=true"
import script from "./card-videos.vue?vue&type=script&lang=js"
export * from "./card-videos.vue?vue&type=script&lang=js"
import style0 from "./card-videos.vue?vue&type=style&index=0&id=5bf50498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf50498",
  null
  
)

export default component.exports